import React, { useState, useEffect } from 'react';




import { useNavigate } from 'react-router-dom';




import {




  ThemeProvider, useTheme, SectionCard, Topbar, LoadingScreen, EmptyState, StatusBadge




} from '../shared/DashWidgets';




import Sidebar from '../shared/Sidebar';




import { buildStyles, COLORS } from '../shared/DashTheme';




import { useAuth } from '../../context/AuthContext';




import api from '../../services/api';









const MONTHS = [




  'January','February','March','April','May','June',




  'July','August','September','October','November','December'




];









const STATUS_CFG = [




  { key: 'pending',   label: 'Pending',   color: COLORS.amber  },




  { key: 'verified',  label: 'Verified',  color: COLORS.blue   },




  { key: 'resolved',  label: 'Resolved',  color: COLORS.green  },




  { key: 'rejected',  label: 'Rejected',  color: COLORS.red    },




  { key: 'escalated', label: 'Escalated', color: COLORS.orange },




];









function StatusBar({ total, pending, verified, resolved, rejected, escalated }) {




  const safe = total || 1;




  const segs = [




    { label: 'Pending',   count: pending   || 0, color: COLORS.amber  },




    { label: 'Verified',  count: verified  || 0, color: COLORS.blue   },




    { label: 'Resolved',  count: resolved  || 0, color: COLORS.green  },




    { label: 'Rejected',  count: rejected  || 0, color: COLORS.red    },




    { label: 'Escalated', count: escalated || 0, color: COLORS.orange },




  ].filter(s => s.count > 0);




  return (




    <div style={{ marginBottom: 14 }}>




      <div style={{ display: 'flex', height: 12, borderRadius: 8, overflow: 'hidden', gap: 2, marginBottom: 8 }}>




        {segs.length === 0




          ? <div style={{ flex: 1, background: 'rgba(255,255,255,0.1)', borderRadius: 4 }} />




          : segs.map(s => (




            <div key={s.label} title={s.label + ': ' + s.count}




              style={{ flex: s.count, background: s.color, borderRadius: 4, transition: 'flex 0.5s ease' }} />




          ))




        }




      </div>




      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>




        {segs.map(s => (




          <div key={s.label} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>




            <div style={{ width: 8, height: 8, borderRadius: '50%', background: s.color }} />




            <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)' }}>




              {s.label} <strong style={{ color: '#fff' }}>{s.count}</strong>




              <span style={{ color: 'rgba(255,255,255,0.4)', marginLeft: 3 }}>




                ({Math.round((s.count / safe) * 100)}%)




              </span>




            </span>




          </div>




        ))}




      </div>




    </div>




  );




}









function StatTile({ label, value, color }) {




  return (




    <div style={{




      flex: 1, minWidth: 80, padding: '12px 10px', borderRadius: 12, textAlign: 'center',




      background: 'rgba(255,255,255,0.07)', border: '1px solid ' + color + '33',




      borderTop: '3px solid ' + color, animation: 'fadeUp 0.4s ease-out both',




    }}>




      <div style={{ fontSize: 20, fontWeight: 800, color: '#fff' }}>{value}</div>




      <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.55)', marginTop: 2 }}>{label}</div>




    </div>




  );




}









function StatusBlock({ label, color, complaints, onView }) {




  const [open, setOpen] = useState(false);




  if (!complaints || complaints.length === 0) return null;




  return (




    <div style={{




      borderRadius: 12, overflow: 'hidden', marginBottom: 8,




      border: '1px solid ' + color + '33', background: 'rgba(255,255,255,0.04)',




    }}>




      <div onClick={() => setOpen(o => !o)} style={{




        padding: '9px 14px', cursor: 'pointer',




        display: 'flex', justifyContent: 'space-between', alignItems: 'center',




        background: color + '18',




      }}>




        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>




          <div style={{ width: 8, height: 8, borderRadius: '50%', background: color }} />




          <span style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>{label}</span>




          <span style={{




            fontSize: 11, padding: '1px 8px', borderRadius: 10,




            background: color + '33', color, fontWeight: 700,




          }}>{complaints.length}</span>




        </div>




        <span style={{




          fontSize: 11, color: 'rgba(255,255,255,0.45)',




          transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s',




        }}>▼</span>




      </div>




      {open && (




        <div style={{ padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 8 }}>




          {complaints.map((c, i) => (




            <div key={c.id} className="ur-card-hover"




              onClick={() => onView && onView(c.id)}




              style={{




                padding: '10px 12px', borderRadius: 10, cursor: 'pointer',




                background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)',




                borderLeft: '3px solid ' + color,




                animation: 'fadeUp 0.3s ease-out both', animationDelay: (i * 0.03) + 's',




              }}>




              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>




                <span style={{ fontSize: 13, fontWeight: 600, color: '#fff', flex: 1, marginRight: 8 }}>{c.title}</span>




                <StatusBadge status={c.status} />




              </div>




              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>




                <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)' }}>By: {c.student_name}</span>




                {c.department && <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>{c.department}</span>}




                {c.university_category && <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>{c.university_category}</span>}




                <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>




                  {c.created_at ? new Date(c.created_at).toLocaleDateString() : ''}




                </span>




                {c.escalation_level > 0 && (




                  <span style={{ fontSize: 11, color: COLORS.orange, fontWeight: 600 }}>Escalated</span>




                )}




              </div>




            </div>




          ))}




        </div>




      )}




    </div>




  );




}









function HistoryCard({ report, index, onView }) {




  const [open, setOpen] = useState(false);




  const rc = { submitted: COLORS.amber, reviewed: COLORS.blue, acknowledged: COLORS.green };




  const cbs = report.complaints_by_status || {};




  return (




    <div style={{




      borderRadius: 14, overflow: 'hidden',




      background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)',




      borderLeft: '3px solid ' + (rc[report.status] || COLORS.purple),




      animation: 'fadeUp 0.4s ease-out both', animationDelay: (index * 0.05) + 's',




    }}>




      <div onClick={() => setOpen(o => !o)} style={{




        padding: '14px 18px', cursor: 'pointer',




        display: 'flex', justifyContent: 'space-between', alignItems: 'center',




      }}>




        <div>




          <div style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 4 }}>




            {MONTHS[report.month - 1]} {report.year}




          </div>




          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>




            {[




              ['Total',    report.total_complaints,    COLORS.purple],




              ['Pending',  report.pending_complaints,  COLORS.amber],




              ['Verified', report.verified_complaints, COLORS.blue],




              ['Resolved', report.resolved_complaints, COLORS.green],




              ['Rejected', report.rejected_complaints, COLORS.red],




            ].map(([l, v, c]) => (




              <span key={l} style={{ fontSize: 11, color: c, fontWeight: 600 }}>{l}: {v}</span>




            ))}




          </div>




        </div>




        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>




          <StatusBadge status={report.status} />




          <span style={{




            fontSize: 11, color: 'rgba(255,255,255,0.4)',




            transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s',




          }}>▼</span>




        </div>




      </div>




      {open && (




        <div style={{ padding: '0 18px 18px' }}>




          <StatusBar




            total={report.total_complaints} pending={report.pending_complaints}




            verified={report.verified_complaints} resolved={report.resolved_complaints}




            rejected={report.rejected_complaints} escalated={report.escalated_complaints}




          />




          {[




            ['Summary',          report.summary],




            ['Challenges Faced', report.challenges],




            ['Actions Taken',    report.actions_taken],




            ['Recommendations',  report.recommendations],




          ].map(([title, text]) => text ? (




            <div key={title} style={{ marginBottom: 12 }}>




              <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 4 }}>{title}</div>




              <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.75)', lineHeight: 1.6 }}>{text}</div>




            </div>




          ) : null)}




          <div style={{ marginTop: 14 }}>




            <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 10 }}>




              Complaints Submitted with Report




            </div>




            {STATUS_CFG.map(sc => (




              <StatusBlock key={sc.key} label={sc.label} color={sc.color}




                complaints={cbs[sc.key] || []} onView={onView} />




            ))}




          </div>




          {report.authority_note && (




            <div style={{ marginTop: 12, padding: '10px 14px', borderRadius: 10, background: 'rgba(99,102,241,0.15)', border: '1px solid rgba(99,102,241,0.3)' }}>




              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 3 }}>Authority Note</div>




              <div style={{ fontSize: 13, color: '#c4b5fd', lineHeight: 1.5 }}>{report.authority_note}</div>




            </div>




          )}




          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginTop: 12 }}>




            Submitted {new Date(report.submitted_at).toLocaleDateString()}




            {report.reviewed_by_name && ' · Reviewed by ' + report.reviewed_by_name}




          </div>




        </div>




      )}




    </div>




  );




}









function AdminReportInner() {




  const { user } = useAuth();




  const { theme } = useTheme();




  const s = buildStyles(theme);




  const navigate = useNavigate();




  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  React.useEffect(() => {
    const h = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);




  const now = new Date();




  const [month, setMonth] = useState(now.getMonth() + 1);




  const [year, setYear]   = useState(now.getFullYear());




  const [stats, setStats]               = useState(null);




  const [history, setHistory]           = useState([]);




  const [loading, setLoading]           = useState(true);




  const [statsLoading, setStatsLoading] = useState(false);




  const [submitting, setSubmitting]     = useState(false);




  const [success, setSuccess]           = useState('');




  const [error, setError]               = useState('');




  const [form, setForm] = useState({ summary: '', challenges: '', actions_taken: '', recommendations: '' });









  useEffect(() => {




    api.get('/admin-reports/my')




      .then(res => setHistory(res.data))




      .catch(() => {})




      .finally(() => setLoading(false));




  }, []);









  useEffect(() => {




    setStatsLoading(true);




    api.get('/admin-reports/stats?month=' + month + '&year=' + year)




      .then(res => setStats(res.data))




      .catch(() => setStats(null))




      .finally(() => setStatsLoading(false));




  }, [month, year]);









  const handleSubmit = async (e) => {




    e.preventDefault();




    if (!form.summary.trim()) { setError('Summary is required'); return; }




    setSubmitting(true); setError('');




    try {




      await api.post('/admin-reports/submit', { month, year, ...form });




      setSuccess('Report for ' + MONTHS[month - 1] + ' ' + year + ' submitted successfully.');




      setForm({ summary: '', challenges: '', actions_taken: '', recommendations: '' });




      const [h, st] = await Promise.all([




        api.get('/admin-reports/my'),




        api.get('/admin-reports/stats?month=' + month + '&year=' + year),




      ]);




      setHistory(h.data);




      setStats(st.data);




    } catch (err) {




      setError(err.response?.data?.error || 'Failed to submit report');




    } finally {




      setSubmitting(false);




    }




  };









  const inp = {




    width: '100%', padding: '10px 14px', borderRadius: 10, fontSize: 13,




    background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.2)',




    color: '#fff', outline: 'none', boxSizing: 'border-box',




  };




  const ta  = { ...inp, minHeight: 88, resize: 'vertical', fontFamily: 'inherit' };




  const lbl = { fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.65)', marginBottom: 5, display: 'block', textTransform: 'uppercase', letterSpacing: 0.8 };




  const isUni = user?.admin_type === 'university';
  const scope = isUni ? 'University-wide complaints' : ((user?.department || '') + ' — dept complaints');
  const shareTarget = isUni ? 'University Authority & Higher Authority' : 'Department Authority & Higher Authority';
  const years = Array.from({ length: 5 }, (_, i) => now.getFullYear() - i);









  if (loading) return <LoadingScreen />;









  return (




    <div style={s.page}>




      <div style={s.bgGrid} /><div style={s.bgOrb1} /><div style={s.bgOrb2} /><div style={s.bgOrb3} />




      <div style={s.layout}>




        {sidebarOpen && <Sidebar onToggle={() => setSidebarOpen(o => !o)} />}




        <div style={{ ...s.main, marginLeft: isMobile ? 0 : (sidebarOpen ? 248 : 0), transition: 'margin-left 0.3s ease' }}>




          <Topbar




            title="Monthly Report"




            subtitle={'Submit your monthly report to authority — ' + scope}




            onToggleSidebar={() => setSidebarOpen(o => !o)}




            actions={




              <div style={{ display: 'flex', gap: 8 }}>




                <button className="ur-btn-hover" style={s.btnSecondary} onClick={() => navigate('/admin/complaints-history')}>




                  Complaint History




                </button>




                <button className="ur-btn-hover" style={s.btnSecondary} onClick={() => navigate('/dashboard')}>




                  Dashboard




                </button>




              </div>




            }




          />




          <div style={s.content}>




            {success && <div style={{ ...s.alertOk, marginBottom: 16, cursor: 'pointer' }} onClick={() => setSuccess('')}>{success}</div>}




            {error   && <div style={{ ...s.alertErr, marginBottom: 16, cursor: 'pointer' }} onClick={() => setError('')}>{error}</div>}









            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.1fr', gap: 20, alignItems: 'start' }}>









              <SectionCard title="Submit Monthly Report" subtitle={scope} delay="0.05s">




                <form onSubmit={handleSubmit}>




                  <div style={{ display: 'flex', gap: 12, marginBottom: 18 }}>




                    <div style={{ flex: 1 }}>




                      <label style={lbl}>Month</label>




                      <select value={month} onChange={e => setMonth(Number(e.target.value))} style={inp}>




                        {MONTHS.map((m, i) => <option key={i} value={i + 1} style={{ background: '#1e293b' }}>{m}</option>)}




                      </select>




                    </div>




                    <div style={{ flex: 1 }}>




                      <label style={lbl}>Year</label>




                      <select value={year} onChange={e => setYear(Number(e.target.value))} style={inp}>




                        {years.map(y => <option key={y} value={y} style={{ background: '#1e293b' }}>{y}</option>)}




                      </select>




                    </div>




                  </div>









                  {statsLoading




                    ? <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginBottom: 16 }}>Loading stats...</div>




                    : stats && (




                      <div style={{ marginBottom: 18 }}>




                        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', marginBottom: 8 }}>




                          Auto-computed for {MONTHS[month - 1]} {year}




                          {stats.already_submitted && (




                            <span style={{ color: COLORS.amber, marginLeft: 8 }}>Already submitted — will overwrite</span>




                          )}




                        </div>




                        <StatusBar




                          total={stats.total} pending={stats.pending} verified={stats.verified}




                          resolved={stats.resolved} rejected={stats.rejected} escalated={stats.escalated}




                        />




                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>




                          <StatTile label="Total"    value={stats.total}    color={COLORS.purple} />




                          <StatTile label="Pending"  value={stats.pending}  color={COLORS.amber}  />




                          <StatTile label="Verified" value={stats.verified} color={COLORS.blue}   />




                          <StatTile label="Resolved" value={stats.resolved} color={COLORS.green}  />




                          <StatTile label="Rejected" value={stats.rejected} color={COLORS.red}    />




                          <StatTile label="Avg Days" value={stats.avg_days} color={COLORS.cyan}   />




                        </div>




                        {stats.complaints_by_status && (




                          <div>




                            <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 8 }}>




                              Complaints Submitted with Report




                            </div>




                            {STATUS_CFG.map(sc => (




                              <StatusBlock key={sc.key} label={sc.label} color={sc.color}




                                complaints={stats.complaints_by_status[sc.key] || []}




                                onView={id => navigate('/complaints/' + id)} />




                            ))}




                          </div>




                        )}




                      </div>




                    )




                  }









                  <div style={{ marginBottom: 12 }}>




                    <label style={lbl}>Summary <span style={{ color: COLORS.red }}>*</span></label>




                    <textarea style={ta} placeholder="Describe overall activity this month..."




                      value={form.summary} onChange={e => setForm(f => ({ ...f, summary: e.target.value }))} required />




                  </div>




                  <div style={{ marginBottom: 12 }}>




                    <label style={lbl}>Challenges Faced</label>




                    <textarea style={ta} placeholder="Any difficulties or blockers..."




                      value={form.challenges} onChange={e => setForm(f => ({ ...f, challenges: e.target.value }))} />




                  </div>




                  <div style={{ marginBottom: 12 }}>




                    <label style={lbl}>Actions Taken</label>




                    <textarea style={ta} placeholder="Steps taken to resolve complaints..."




                      value={form.actions_taken} onChange={e => setForm(f => ({ ...f, actions_taken: e.target.value }))} />




                  </div>




                  <div style={{ marginBottom: 18 }}>




                    <label style={lbl}>Recommendations</label>




                    <textarea style={ta} placeholder="Suggestions for authority..."




                      value={form.recommendations} onChange={e => setForm(f => ({ ...f, recommendations: e.target.value }))} />




                  </div>









                  <div style={{ padding:'10px 14px', borderRadius:10, marginBottom:12,

                    background:'rgba(99,102,241,0.12)', border:'1px solid rgba(99,102,241,0.25)' }}>

                    <div style={{ fontSize:12, color:'rgba(255,255,255,0.7)', lineHeight:1.5 }}>

                      The full complaint list for this month will be automatically attached to the report and shared with authority.

                    </div>

                  </div>

                  <div style={{ padding:'10px 14px', borderRadius:10, marginBottom:12,
                    background:'rgba(99,102,241,0.12)', border:'1px solid rgba(99,102,241,0.25)' }}>
                    <div style={{ fontSize:12, color:'rgba(255,255,255,0.7)', lineHeight:1.5 }}>
                      Report will be shared with: <strong style={{color:'#c4b5fd'}}>{shareTarget}</strong>
                    </div>
                  </div>
                  <button type="submit" className="ur-btn-hover" disabled={submitting}




                    style={{ ...s.btnPrimary, width: '100%', justifyContent: 'center', display: 'flex', opacity: submitting ? 0.7 : 1 }}>




                    {submitting ? 'Submitting...' : 'Submit Report + Complaint List — ' + MONTHS[month - 1] + ' ' + year}




                  </button>




                </form>




              </SectionCard>









              <SectionCard title="Submitted Reports" subtitle="Your report history — click to expand" delay="0.1s">




                {!history.length




                  ? <EmptyState text="No reports submitted yet" sub="Submit your first monthly report" />




                  : (




                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxHeight: 820, overflowY: 'auto' }}>




                      {history.map((r, i) => (




                        <HistoryCard key={r.id} report={r} index={i}




                          onView={id => navigate('/complaints/' + id)} />




                      ))}




                    </div>




                  )




                }




              </SectionCard>




            </div>




          </div>




        </div>




      </div>




    </div>




  );




}









export default function AdminReport() {




  return <ThemeProvider><AdminReportInner /></ThemeProvider>;




}




